<template>
  <BaseModal
    :value="dialogState"
    :modal-title="$t('workflow.status.question.deleteChamp')"
    @click:outside="close"
    @keydown.esc="close"
    @close="close"
  >
    <template #modal>
      <div v-if="activeQuestion" class="text-center">
        <BaseParagraph v-text="message" />
        <div
          v-if="
            activeQuestion.isOperationResult || activeQuestion.isOperationSource
          "
          class="alert_operation"
        >
          {{ operationLabel }}
        </div>
      </div>
    </template>
    <template #actions>
      <BaseButton
        text
        class="mx-2 ml-auto"
        type="secondary"
        color="#707080"
        @click="close"
      >
        {{ $t("utils.cancel") }}
      </BaseButton>
      <BaseButton color="secondary" type="primary" @click="submit">
        {{ $t("utils.delete") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import workflowApi from "../Services/workflow.api";
import { deleteOrganizationWorkflowStatusQuestion } from "@/modules/Admin/Services/workflow.service";

export default {
  name: "WorkflowStatusQuestionDeleteDialog",
  props: {
    dialogState: {
      type: Boolean,
    },
    workflowId: {
      type: Number,
      required: true,
    },
    status: {
      type: Object,
      required: true,
    },
    activeQuestion: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      questionUsage: [],
    };
  },
  computed: {
    message() {
      return this.activeQuestion.isOperationResult ||
        this.activeQuestion.isOperationSource
        ? this.$t("workflow.operation.confirmDeletionOperations")
        : this.$t("workflow.status.question.deleteChampConfirmation", {
            count: this.activeQuestion && this.activeQuestion.answersCount,
          });
    },
    operationLabel() {
      if (!this.questionUsage) return "";
      return this.questionUsage.map((usage) => usage.label)?.join(", ");
    },
  },

  watch: {
    dialogState() {
      if (this.dialogState) this.getUsage();
    },
  },
  methods: {
    async getUsage() {
      const response = await workflowApi.getOrganizationWorkflowOperationUsage({
        organizationId: this.$route.params.organizationId,
        workflowId: this.workflowId,
        statusId: this.status.id,
        questionId: this.activeQuestion.id,
      });
      this.questionUsage = response.data.results;
    },
    close() {
      this.$emit("close");
    },
    async submit() {
      try {
        await deleteOrganizationWorkflowStatusQuestion(
          this.$route.params.organizationId,
          this.workflowId,
          this.status.id,
          this.activeQuestion.id
        );
        this.$emit("questionDeleted", this.activeQuestion.id);
        this.$store.dispatch("snackbar/active", {
          message: this.$t("course.deleteQuestionConfirmation"),
          type: "SUCCESS",
        });
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      if (this.questionUsage.length) this.$emit("update-automated");
      this.close();
    },
  },
};
</script>
<style scoped>
.alert_operation {
  color: #ff5267;
}
</style>
